import { transactionHistory } from '../../util/api';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const CURRENT_USER_SHOW_REQUEST = 'app/TransactionHistoryPage/CURRENT_USER_SHOW_REQUEST';
export const CURRENT_USER_SHOW_SUCCESS = 'app/TransactionHistoryPage/CURRENT_USER_SHOW_SUCCESS';
export const CURRENT_USER_SHOW_ERROR = 'app/TransactionHistoryPage/CURRENT_USER_SHOW_ERROR';

export const CLEAR_CURRENT_USER = 'app/user/CLEAR_CURRENT_USER';

// ================ Reducer ================ //

const mergeCurrentUser = (oldCurrentUser, newCurrentUser) => {
    const { id: oId, type: oType, attributes: oAttr, ...oldRelationships } = oldCurrentUser || {};
    const { id, type, attributes, ...relationships } = newCurrentUser || {};

    // Passing null will remove currentUser entity.
    // Only relationships are merged.
    // TODO figure out if sparse fields handling needs a better handling.
    return newCurrentUser === null
        ? null
        : oldCurrentUser === null
            ? newCurrentUser
            : { id, type, attributes, ...oldRelationships, ...relationships };
};

const initialState = {
    currentUserTransactionHistory: null,
    currentUserTransactionHistoryInProgress: false,
    currentUserTransactionHistoryShowError: null,
    currentUserTransactionHistoryListings: null,

};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case CURRENT_USER_SHOW_REQUEST:
            return { ...state, currentUserTransactionHistoryInProgress: true, currentUserTransactionHistoryShowError: null };
        case CURRENT_USER_SHOW_SUCCESS:
            return { ...state, currentUserTransactionHistoryInProgress: false, currentUserTransactionHistory: mergeCurrentUser(state.currentUserTransactionHistory, payload) };
        case CURRENT_USER_SHOW_ERROR:
            // eslint-disable-next-line no-console
            console.error(payload);
            return { ...state, currentUserTransactionHistoryInProgress: false, currentUserTransactionHistoryShowError: payload };

        case CLEAR_CURRENT_USER:
            return {
                ...state,
                currentUserTransactionHistory: null,
                currentUserTransactionHistoryShowError: null,
            };

        default:
            return state;
    }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const currentUserShowRequest = () => ({ type: CURRENT_USER_SHOW_REQUEST });

export const currentUserShowSuccess = user => ({
    type: CURRENT_USER_SHOW_SUCCESS,
    payload: user,
});

export const currentUserShowError = e => ({
    type: CURRENT_USER_SHOW_ERROR,
    payload: e,
    error: true,
});


// ================ Thunks ================ //


export const fetchCurrentUserTransactionHistory = (page) => async (dispatch, getState, sdk) => {
    dispatch(currentUserShowRequest());

    const { isAuthenticated } = getState().auth;
    let currentUserr;
    if (!isAuthenticated) {
        dispatch(currentUserShowSuccess(null));
        return Promise.resolve({});
    }

    if (getState().user?.currentUser) {
        currentUserr = getState().user?.currentUser;

    } else {
        currentUserr = await sdk.currentUser.show()
    }

    if (!currentUserr) {
        console.warn('No current user ID found');
        dispatch(currentUserShowSuccess(null));
        return Promise.resolve({});
    }

    const currentUserId = currentUserr && currentUserr?.id?.uuid || currentUserr.data.data?.id.uuid;

    try {
        const res = await transactionHistory({
            buyerId: currentUserId,
            page,
        });

        if (res?.data) {
            dispatch(currentUserShowSuccess(res));
        }

    } catch (error) {
        console.error('Error fetching transaction history:', error);
        // You can also dispatch an error action here
    }
};


export const loadData = (params, search, config) => (dispatch, getState) => {
    const queryParams = parse(search, {
        latlng: ['origin'],
        latlngBounds: ['bounds'],
    });
    const { page = 1, address, origin, ...rest } = queryParams;
    return dispatch(fetchCurrentUserTransactionHistory(page));
};